import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Button } from "react-bootstrap";
import VerticalInputField from "./fields/VerticalInputField";
import VerticalSelectField from "./fields/VerticalSelectField";
import VerticalNumberField from "./fields/VerticalNumberField";
import JobItemTypeSelect from "./fields/JobItemTypeSelect";
import { required } from "./validators";

const WeightUom = () => (
  <Field
    component={VerticalSelectField}
    name="item.weightUom"
    label="Unit of Measurement"
  >
    <option value="" />
    <option value="kgs">kgs</option>
    <option value="tonnes">tonnes</option>
  </Field>
);

const JobItemForm = ({ action, handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Row>
      <Col sm={6}>
        <Field
          name="item.quantity"
          component={VerticalNumberField}
          type="number"
          label="Quantity*"
          placeholder="Quantity"
          validate={[required]}
          min={1}
        />
      </Col>
      <Col sm={6}>
        <JobItemTypeSelect />
      </Col>
    </Row>

    <Row>
      <Col sm={12}>
        <Field
          name="item.description"
          component={VerticalInputField}
          type="text"
          label="Description*"
          placeholder="Description"
          validate={[required]}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={4}>
        <Field
          name="item.weight"
          component={VerticalNumberField}
          type="number"
          label="Weight"
          placeholder="Weight"
          min={1}
        />
      </Col>
      <Col sm={4}>
        <WeightUom />
      </Col>
      <Col sm={4}>
        <Button className="add-item-btn" type="submit" bsStyle="primary">
          {action === "Edit" ? "UPDATE" : "ADD"} ITEM
        </Button>
      </Col>
    </Row>
  </form>
);
JobItemForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  action: PropTypes.string
};
JobItemForm.defaultProps = {
  action: "ADD"
};

export default reduxForm({ form: "jobItem", enableReinitialize: true })(
  JobItemForm
);



// WEBPACK FOOTER //
// ./src/forms/JobItemForm.js